import React from 'react';
import { Button } from '@chakra-ui/react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from 'provider';
import { PATHS } from 'router/routes';
import { useUserSubscription } from '../../../hooks/useRequireSubscription';

import TrustpilotWidget from './TrustPilotWidget';
import { Image } from '@chakra-ui/react';
import zaraLogoWhite from '../../../assets/images/ZaraLogo20251104.png';

// @ts-ignore

import { Menu, HelpCircle, LogOut } from 'lucide-react';
import { checkCurrentPage } from 'utils';

const baseButtonStyles = {
    variant: 'plain',
    justifyContent: 'start',
    className:
        'w-full justify-start px-4 py-2 text-left hover:bg-white hover:text-black transition-colors rounded-md mb-1',
};

interface Props {
    isMenuOpen: boolean;
    setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar = ({ isMenuOpen, setIsMenuOpen }: Props) => {
    const router = useNavigate();
    const { signOut } = useAuth();
    const location = useLocation();
    const { pathname } = location;
    const subscription = useUserSubscription();

    const onLogOut = () => {
        signOut();
        router(PATHS.SIGN_IN);
    };

    let routes = [
        {
            name: 'My Agent',
            path: PATHS.MY_AGENT,
        },
        {
            name: 'Call Activity',
            path: PATHS.CALL_ACTIVITY,
        },
        ...(subscription
            ? [
                {
                    name: 'Integrations',
                    path: PATHS.AUTOMATION_TEMPLATE,
                },
            ]
            : []),
        {
            name: 'Profile',
            path: PATHS.PROFILE_INFO,
        },
        ...(subscription
            ? [
                {
                    name: 'Subscription',
                    path: PATHS.SUBSCRIPTION,
                },
            ]
            : []),
    ];



    return (
        <>
            <aside
                className={`bg-[#050536] text-white w-64 fixed inset-y-0 left-0 transform ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'
                    } lg:translate-x-0 transition-transform duration-200 ease-in-out z-30 flex flex-col`}
            >
                <div className='flex items-center justify-between h-16 px-6'>
                    <Image
                        onMouseDown={(e) => e.preventDefault()}
                        alt='Zara Logo'
                        width='188px'
                        height='30px'
                        src={zaraLogoWhite}
                    />
                    <div className='lg:hidden'>
                        <Button variant='plain' justifyContent='start' size='icon' onClick={() => setIsMenuOpen(false)}>
                            <Menu className='h-6 w-6' />
                        </Button>
                    </div>
                </div>
                <nav className='flex-grow mt-8 px-2'>
                    {routes.map((route) => {
                        const isActivePage =
                            checkCurrentPage(route.path, pathname) ||
                            (route.path.includes('profile') && pathname.includes('profile'));
                        return (
                            <Link
                                key={route.name}
                                to={route.path}
                                className={`w-full justify-start px-4 py-2 text-left hover:bg-white hover:text-black transition-colors rounded-md mb-1 block font-bold ${isActivePage ? 'bg-white text-black' : ''
                                    }`}
                            >
                                {route.name}
                            </Link>
                        );
                    })}
                </nav>
                <div className='mt-auto mb-4 px-2'>
                    <TrustpilotWidget />
                    {/* <Button {...baseButtonStyles}>
                        <Star className='w-4 h-4 mr-2' />
                        Leave a Review
                    </Button> */}
                    <Button {...baseButtonStyles} onClick={() => window.open(' https://guide.dialzara.com', '_blank')}>
                        <HelpCircle className='w-4 h-4 mr-2' />
                        Help
                    </Button>
                    <Button onClick={onLogOut} {...baseButtonStyles}>
                        <LogOut className='w-4 h-4 mr-2' />
                        Log Out
                    </Button>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
